if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.initialized = false;
        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        var self = this;
        var mediaCount = parseInt(self.dataset.mediaCount || '1', 10);
        var enableMobileThumbnails = self.dataset.enableMobileThumbnails === 'true';

        self.staticMobileGallery =
          window.matchMedia('(max-width: 767px)').matches &&
          !enableMobileThumbnails &&
          mediaCount > 1;

        function scheduleInit() {
          if (typeof FoxTheme === 'undefined' || !FoxTheme.Motion) {
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
            } else {
              setTimeout(scheduleInit, 16);
            }
            return;
          }

          var rect = self.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            self.init();
            return;
          }

          FoxTheme.Motion.inView(self, self.init.bind(self));
        }

        if (self.dataset.enableImageZoom === 'true') {
          self.bindLazyImageZoom();
        }

        if (self.staticMobileGallery) {
          self.bindStaticMobileGallery(scheduleInit);
          return;
        }

        if (self.dataset.onlyImage === 'true') {
          function quickInit() {
            if (typeof FoxTheme === 'undefined') {
              setTimeout(quickInit, 16);
              return;
            }
            self.init();
          }
          quickInit();
          return;
        }

        scheduleInit();
      }

      hydrateDeferredGalleryImages(root) {
        var scope = root && root.querySelectorAll ? root : this;
        scope.querySelectorAll('img[data-snr-deferred-src]').forEach(function (img) {
          if (img.dataset.snrHydrated === '1') return;
          img.dataset.snrHydrated = '1';
          img.src = img.dataset.snrDeferredSrc;
          if (img.dataset.snrDeferredSrcset) {
            img.srcset = img.dataset.snrDeferredSrcset;
          }
          var slide = img.closest('.snr-deferred-gallery-slide');
          if (slide) slide.classList.add('snr-gallery-hydrated');
        });
      }

      hydrateSlideByMediaId(mediaId) {
        if (!mediaId) return;
        var slide = this.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');
        if (slide) this.hydrateDeferredGalleryImages(slide);
      }

      bindThumbnailHydration() {
        var self = this;
        this.addEventListener(
          'click',
          function (event) {
            var thumb = event.target.closest('.product__thumbs-item[data-target]');
            if (!thumb) return;
            self.hydrateSlideByMediaId(thumb.dataset.target);
          },
          { passive: true }
        );
      }

      hydrateSlidesWithoutSlider() {
        var self = this;
        this.querySelectorAll('.product__media-item').forEach(function (slide) {
          if (FoxTheme.config.mqlMobile && typeof FoxTheme.Motion?.inView === 'function') {
            FoxTheme.Motion.inView(slide, function () {
              self.hydrateDeferredGalleryImages(slide);
            });
          } else {
            self.hydrateDeferredGalleryImages(slide);
          }
        });
      }

      bindLazyImageZoom() {
        if (this.lazyZoomBound) return;
        this.lazyZoomBound = true;

        var self = this;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var swipeGesture = { active: false, moved: false, startX: 0, startY: 0 };

        if (isMobile) {
          this.addEventListener(
            'pointerdown',
            function (event) {
              if (!event.target.closest('.js-photoswipe--zoom, .product__media-gallery-viewer')) return;
              swipeGesture.active = true;
              swipeGesture.moved = false;
              swipeGesture.startX = event.clientX;
              swipeGesture.startY = event.clientY;
            },
            { passive: true }
          );

          this.addEventListener(
            'pointermove',
            function (event) {
              if (!swipeGesture.active || swipeGesture.moved) return;
              if (
                Math.abs(event.clientX - swipeGesture.startX) > 14 ||
                Math.abs(event.clientY - swipeGesture.startY) > 14
              ) {
                swipeGesture.moved = true;
              }
            },
            { passive: true }
          );

          this.addEventListener(
            'pointerup',
            function () {
              swipeGesture.active = false;
            },
            { passive: true }
          );
        }

        this.addEventListener(
          'click',
          function (event) {
            var trigger = event.target.closest('.js-photoswipe--zoom');
            if (!trigger || trigger.dataset.mediaType !== 'image') return;
            if (isMobile && swipeGesture.moved) return;

            event.preventDefault();
            event.stopPropagation();

            var index = Number(trigger.dataset.mediaIndex) || 0;
            self.hydrateSlideByMediaId(trigger.dataset.mediaId);
            self.openImageZoom(index);
          },
          true
        );
      }

      openImageZoom(index) {
        var self = this;
        var attempts = 0;

        function tryOpen() {
          if (self.initImageZoom()) {
            self.lightbox.loadAndOpen(index);
            return;
          }
          if (attempts++ < 40) {
            window.setTimeout(tryOpen, 50);
          }
        }

        tryOpen();
      }

      bindStaticMobileGallery(scheduleInit) {
        var self = this;
        var sliderActivated = false;
        var panGesture = { tracking: false, moved: false, startX: 0, startY: 0 };

        function activateSlider() {
          if (sliderActivated) return;
          sliderActivated = true;
          self.hydrateDeferredGalleryImages();
          self.staticMobileGallery = false;
          self.classList.remove('snr-static-mobile');
          var viewer = self.querySelector('.product__media-gallery-viewer');
          if (viewer) viewer.classList.remove('snr-static-mobile');
          self.initialized = false;
          scheduleInit();
        }

        self.classList.add('snr-static-mobile');
        var viewer = self.querySelector('.product__media-gallery-viewer');
        if (viewer) viewer.classList.add('snr-static-mobile');

        self.addEventListener(
          'pointerdown',
          function (event) {
            if (event.target.closest('.js-photoswipe--zoom, .product__media-icon')) return;
            if (event.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination')) {
              activateSlider();
              return;
            }
            if (!event.target.closest('.product__media-gallery-viewer')) return;
            panGesture.tracking = true;
            panGesture.moved = false;
            panGesture.startX = event.clientX;
            panGesture.startY = event.clientY;
          },
          { passive: true }
        );

        self.addEventListener(
          'pointermove',
          function (event) {
            if (!panGesture.tracking || sliderActivated || panGesture.moved) return;
            if (
              Math.abs(event.clientX - panGesture.startX) > 14 ||
              Math.abs(event.clientY - panGesture.startY) > 14
            ) {
              panGesture.moved = true;
              activateSlider();
            }
          },
          { passive: true }
        );

        self.addEventListener(
          'pointerup',
          function () {
            panGesture.tracking = false;
          },
          { passive: true }
        );
      }

      init() {
        if (this.initialized === true) return;
        if (this.staticMobileGallery) return;

        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.context = this.dataset.context;
        this.mediaCount = parseInt(this.dataset.mediaCount || '1', 10);

        if (this.onlyImage) {
          this.initialized = true;
          return;
        }

        this.setSliderOptions();
        this.bindThumbnailHydration();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (!this.sliderInstance) {
          this.hydrateSlidesWithoutSlider();
        }

        this.initialized = true;
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);
        const mediaItemGapMobile = parseInt(this.dataset.mediaItemGapMobile);

        const mobileSlidesPerView =
          this.enableMobileThumbnails || this.mediaCount > 6 ? 1 : 'auto';

        this.sliderOptions = {
          init: false,
          slidesPerView: mobileSlidesPerView,
          spaceBetween: mediaItemGapMobile,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
              direction: 'horizontal',
            },
          },
          spaceBetween: mediaItemGapMobile,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              768: {
                direction: 'vertical',
                slidesPerView: 'auto',
                spaceBetween: mediaItemGap,
              },
            };
            break;
          case 'carousel':
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              1024: {
                slidesPerView: 5,
              },
              1536: {
                slidesPerView: 7,
              },
            };
            break;
        }
      }

      updateMediaLayout() {
        if (this.staticMobileGallery) {
          return;
        }

        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        if (this.lightbox) return true;
        if (!window.FoxTheme?.PhotoSwipeLightbox || !window.FoxTheme?.PhotoSwipe) {
          return false;
        }

        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            const { mediaType, mediaIndex, src, pswpWidth, pswpHeight } = media.dataset;

            let source = {
              id: mediaIndex,
              mediaType: mediaType,
            };

            switch (mediaType) {
              case 'model':
              case 'video':
              case 'external_video':
                const htmlTag = mediaType === 'model' ? 'product-model' : 'video-element';

                source = {
                  ...source,
                  html: `<div class="pswp__item--${mediaType}">${media.querySelector(htmlTag).outerHTML}</div>`,
                };
                break;
              default: // Image.
                source = {
                  ...source,
                  src: src,
                  width: pswpWidth,
                  height: pswpHeight,
                };
                break;
            }

            dataSource.push(source);
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          const slider = this.sliderInstance?.slider;

          if (slider) {
            const { slides, activeIndex } = slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          const slider = this.sliderInstance?.slider;

          if (slider) {
            const { slides, activeIndex } = slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        // Store the current index before closing
        let lastLightboxIndex = null;
        this.lightbox.on('close', () => {
          if (this.lightbox?.pswp?.currIndex) {
            lastLightboxIndex = this.lightbox.pswp.currIndex;
          }
        });

        // Update slider after lightbox is destroyed
        this.lightbox.on('destroy', () => {
          const slider = this.sliderInstance?.slider;

          if (slider && lastLightboxIndex !== null) {
            const targetIndex = lastLightboxIndex;
            // currIndex from lightbox is the index in dataSource array
            // which should match the slider index since both are created from the same media items in the same order
            if (targetIndex >= 0 && targetIndex < slider.slides.length && slider.activeIndex !== targetIndex) {
              // Use requestAnimationFrame to ensure DOM is ready
              requestAnimationFrame(() => {
                slider.slideTo(targetIndex, 0);
              });
            }
            lastLightboxIndex = null;
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox?.pswp?.currSlide?.data?.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          const lightboxUI = this.lightbox?.pswp?.ui;

          if (!lightboxUI) return;

          if (!this.onlyImage) {
            lightboxUI.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox?.pswp?.next();
              },
            });
            lightboxUI.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox?.pswp?.prev();
              },
            });
          }
          lightboxUI.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox?.pswp?.close();
            },
          });
        });

        this.lightbox.init();

        return true;
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);
            if (FoxTheme.config.mqlMobile) {
              this.hydrateDeferredGalleryImages(slides[activeIndex]);
              var nextSlide = slides[activeIndex + 1];
              var prevSlide = slides[activeIndex - 1];
              if (nextSlide) this.hydrateDeferredGalleryImages(nextSlide);
              if (prevSlide) this.hydrateDeferredGalleryImages(prevSlide);
            } else {
              this.hydrateDeferredGalleryImages();
            }

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);
            this.hydrateDeferredGalleryImages(slides[activeIndex]);
            var nextSlide = slides[activeIndex + 1];
            var prevSlide = slides[activeIndex - 1];
            if (nextSlide) this.hydrateDeferredGalleryImages(nextSlide);
            if (prevSlide) this.hydrateDeferredGalleryImages(prevSlide);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        window.pauseAllMedia(this);

        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);

        const videoElement = selected.querySelector('video-element');
        if (videoElement && typeof videoElement.play === 'function') {
          videoElement.play();
        }
      }

      setActiveMedia(variant) {
        if (!variant) return;

        let featuredMedia = variant.featured_media;

        if (!featuredMedia && variant.featured_image) {
          featuredMedia = {
            id: variant.featured_image.id,
            position: variant.featured_image.position || 0,
            media_type: 'image',
          };
        }

        if (!featuredMedia) return;

        if (this.sliderInstance.slider) {
          const slideIndex = featuredMedia.position || 0;
          this.sliderInstance.slider.slideTo(slideIndex - 1, 0, false);
        } else {
          this.sortMediaItems(variant, featuredMedia);
        }
      }

      sortMediaItems(variant, featuredMedia) {
        if (!featuredMedia) {
          featuredMedia =
            variant.featured_media ||
            (variant.featured_image
              ? {
                  id: variant.featured_image.id,
                  position: variant.featured_image.position || 0,
                  media_type: 'image',
                }
              : null);
        }

        if (!featuredMedia) return;

        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == featuredMedia.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile && this.context !== 'quickview') {
          const selectedMedia = this.querySelector(`[data-media-id="${featuredMedia.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
